import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {DetailValue} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, Col, Row} from "reactstrap";
import {formatDate} from "../utils/utils";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Komponenta zobrazující read-only detail karty.
 */
class KartaDetail extends Component<WithTranslation> {

    static propTypes = {
        karta: PropTypes.object.isRequired, // VO karty
    };

    render() {
        const {karta, t} = this.props;
        return <Card>
            <CardBody>
                <Row>
                    <Col xs={12} sm={3}>
                        <DetailValue textOverflow label={t('card_number')}>{karta.cisloKarta}</DetailValue>
                    </Col>
                    <Col xs={12} sm={3}>
                        <DetailValue textOverflow label={t('chip_number')}>{karta.cisloChip}</DetailValue>
                    </Col>
                    <Col xs={12} sm={3}>
                        <DetailValue textOverflow label={t('issue_date')}>{formatDate(karta.datumVydano)}</DetailValue>
                    </Col>
                    <Col xs={12} sm={3}>
                        <DetailValue textOverflow label={t('expiry_date')}>{formatDate(karta.datumPlatnost)}</DetailValue>
                    </Col>
                    <Col xs={12}>
                        <DetailValue textOverflow label="Společnost">{karta.spolecnost ? karta.spolecnost.nazevSpolecnost : "-"}</DetailValue>
                    </Col>
                    <Col xs={12}>
                        <DetailValue textOverflow label="Uživatel">{karta.uzivatel ? karta.uzivatel.zobrazJmeno : "-"}</DetailValue>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(KartaDetail));
